export type TemplateModuleSource = {
  moduleCodes: string[];
};

export type CreateQuotationFormInput = {
  templateCode: string;
  projectTitle: string;
  selectedModuleCodes: string[];
};

export type CreateQuotationPayload =
  | {
      ok: true;
      data: CreateQuotationFormInput;
    }
  | {
      ok: false;
      error: string;
    };

export function getDefaultSelectedModuleCodes(template: TemplateModuleSource): string[] {
  return [...template.moduleCodes];
}

export function toggleModuleCode(selectedModuleCodes: string[], moduleCode: string): string[] {
  if (selectedModuleCodes.includes(moduleCode)) {
    return selectedModuleCodes.filter((selected) => selected !== moduleCode);
  }

  return [...selectedModuleCodes, moduleCode];
}

export function buildCreateQuotationPayload(input: CreateQuotationFormInput): CreateQuotationPayload {
  const templateCode = input.templateCode.trim();
  const projectTitle = input.projectTitle.trim();
  const selectedModuleCodes = input.selectedModuleCodes.filter((moduleCode) => moduleCode.trim().length > 0);

  if (!templateCode) {
    return {
      ok: false,
      error: "Please select a quotation template.",
    };
  }

  if (!projectTitle) {
    return {
      ok: false,
      error: "Please enter a project title.",
    };
  }

  if (selectedModuleCodes.length === 0) {
    return {
      ok: false,
      error: "Please select at least one module.",
    };
  }

  return {
    ok: true,
    data: {
      templateCode,
      projectTitle,
      selectedModuleCodes,
    },
  };
}
